
import { Component, Vue } from 'vue-property-decorator'
import DetailDialog from './DetailDialog.vue'
import IndividualLender from '@/views/bid-details/IndividualLender.vue'
import { ownModelRating, fundChannel } from '@/utils/dictionary'
import http from '@/utils/request'
import { Form, Loading } from 'element-ui'
import { getUserInfo } from '@/utils/user'
import dialogSelect from '@/views/bid-details/component/dialog-select-insurance.vue'
import { isNullOrUndefined } from '@/utils'
import i18n from '@/lang'

@Component({
  components: {
  IndividualLender,
  dialogSelect,
  'app-detail-dialog': DetailDialog
  }
  })
export default class extends Vue {
  private confirmLoading = false
  private list: any[] = []
  private listLoading = true
  private listTotal = 0
  private listQuery = {
    current: 1,
    size: 10,
    //
    isBuy: 1,
    cameraId: '',
    idNo: '',
    riskLevel: '',
    contractAmount: ''
  }

  ids = ''
  idsArr = []
  lendNumber: any = ''
  insuranceData: any = {}
  ojkialogVisible = false
  importanceOptions = [1, 2, 3]
  showDetail = false
  currentRowData: any = {}
  riskLevelList = ownModelRating
  thirdPartySrc = ''
  showThirdPartyDialog = false
  showIndividualLender = false
  private individualLenderData = null
  insureNo: any = ''
  signVos: any[] = []
  selectedRow = []
  openSelectInsurance = false
  insuranceChannel = 0
  detail: any = {
    rate: 0,
    //
    lendNo: '',
    lid: '',
    contractAmount: '',
    interest: ''
  }

  created() {
    this.getList()
  }

  closeIndividualLender(val: boolean) {
    if (val) {
      this.showIndividualLender = false
      this.getList()
    }
  }

  private async getList() {
    this.listLoading = true
    this.initialize().finally(() => (this.listLoading = false))
  }

  //  Tabular data source
  async initialize() {
    return http.post('/lend/list', this.listQuery).then((data) => {
      this.list = data.records
      this.listTotal = data.total
    })
  }

  //  table check
  tableSelect(selection: any) {
    this.selectedRow = selection
    this.signVos = selection.map((item: any) => {
      return {
        cameraId: item.cameraId,
        lendAmount: item.contractAmount,
        interestAmount: item.interest,
        loanBusiId: item.lid,
        qoalaStatus: 2
      }
    })
  }

  async showDynamicMessage(
    message: any,
    isShowConfirmButton = true,
    title = i18n.t('Berita') as string,
    buttonText = i18n.t('Lanjutkan') as string
  ) {
    await this.$msgbox({
      title,
      message: this.$createElement('p', message),
      showCancelButton: false,
      confirmButtonText: buttonText,
      showConfirmButton: isShowConfirmButton
    })
  }

  async handleInsure(obj: any) {
    let selectedList: any = []
    const tipError = i18n.t('Insurance gagal, silakan coba lagi nanti...')
    const tipConfirm = i18n.t('Item ini telah dijamin dan dapat diambil langsung ke langkah berikutnya')
    const res = await this.handleCreate(obj)
    if (res) {
      if (res.status === 1) {
        const tipSuccess = `Insurance successful, insurance number:${res.policyNo},Silakan klik untuk melanjutkan dan melanjutkan ke langkah berikutnya`
        await this.showDynamicMessage(tipSuccess)
          .then(async() => {
            selectedList.push(obj)
            this.tableSelect(selectedList)
            this.onConfirm()
          })
          .catch(() => {
            selectedList = []
          })
      } else if (res.status === 2) {
        await this.showDynamicMessage(tipError, false)
      } else {
        await this.showDynamicMessage(tipConfirm)
          .then(async () => {
            selectedList.push(obj)
            this.tableSelect(selectedList)
            this.onConfirm()
          })
          .catch(() => {
            selectedList = []
          })
      }
    }
  }

  handleCreate(params: any) {
    const { cameraId, lid } = params
    return http.post('/lend/api/insurance/create', { cameraId, lid })
  }

  handleSizeChange(val: number) {
    this.listQuery.size = val
    this.selectedRow = []
    this.getList()
  }

  handleCurrentChange(val: number) {
    this.listQuery.current = val
    this.selectedRow = []
    this.getList()
  }

  isRowSelectable(row: any) {
    const { mid } = getUserInfo('userInfoMap')
    if (row.fundChannel === null) {
      return fundChannel.findIndex(item => item.mid === mid) === -1
    }
    const channel = fundChannel.find(item => item.label === String(row.fundChannel))
    return channel ? channel.mid === mid : false
  }

  view(row: any) {
    this.$router.push({
      path: '/dashboard/bid-details',
      query: { lid: row.lid, qoalaStatus: '4', cameraId: row.cameraId }
    })
  }

  onSearch() {
    this.initialize()
  }

  // Clear
  onReset() {
    // eslint-disable-next-line
    ; (this.$refs.filtersRef as Form).resetFields()
  }

  async getOjkInfo() {
    const { mid: customerId } = getUserInfo('userInfoMap')
    const data = await http.post('/lend/api/os/info', { lendCustomerId: customerId })
    if (data.flag) {
      this.manulBuyBids()
    } else {
      this.ojkialogVisible = true
    }
  }

  manulBuyBids() {
    this.ojkialogVisible = false
    this.openSelectInsurance = true
    this.detail.contractAmount = this.selectedRow.reduce((acc: any, cur: any, index) => {
      acc += cur.contractAmount
      return acc
    }, 0)
  }

  async getIndividualLender(e: any) {
    this.insuranceChannel = isNullOrUndefined(e) ? 0 : e;
    this.openSelectInsurance = false
    const detailLoading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading'
    })
    try {
      const { mid: customerId } = getUserInfo('userInfoMap')
      const lids = this.selectedRow.map((item: any) => item.lid)
      if (e) {
        await this.createInsurance()
      }
      await http.post('/lend/manulBuyBids', { customerId, lids, insuredChannel: e })
      await this.urlRouter()
      this.getList()
    } catch (error) {
      //
    } finally {
      detailLoading.close()
    }
  }

  async urlRouter() {
    const userType = '1'
    const { signVos, insuranceChannel: insurance } = this
    await http
      .post('/sign/sendDocument', {
        signVos,
        insurance,
        userType
      })
      .then((data) => {
        if (data.status === 'Succeed') {
          this.thirdPartySrc = data.link
          this.showThirdPartyDialog = true
        } else if (data.qianming) {
          this.individualLenderData = { ...data }
          this.showIndividualLender = true
        } else {
          this.$message.error(data.digisignMsg)
        }
      })
  }

  async createInsurance() {
    return new Promise((resolve, reject) => {
      let isDone = false
      const lids = this.selectedRow.map((item: any) => item.lid)
      const params = {
        lids,
        // cameraId: this.list.lendNo,
        insuranceChannel: this.insuranceChannel
      };
      http.post('/lend/api/insurance/create', params).then(response => {
        // console.log(response)
        isDone = true
      })
        .catch(() => {})
        .finally(() => { resolve(true) })

      setTimeout(() => {
        if (!isDone) {
          console.log('insurance create request time out.')
          resolve(true)
        }
      }, 8e3)
    })
  }

  // Confirm submission
  // !! this method is deprecated, move to manulBuyBids
  onConfirm() {
    this.$confirm(i18n.t('Konfirm untuk investasi') as string, i18n.t('Peringatan') as string)
      .then(() => {
        /** Confirm acton */
        const lids = this.selectedRow.map((item: any) => item.lid)
        const { mid: customerId } = getUserInfo('userInfoMap')
        this.confirmLoading = true
        // eslint-disable-next-line
        http
          .post('/lend/manulBuyBids', { lids, customerId })
          // eslint-disable-next-line
          .then(async (data) => {
            if (data) {
              // Sent successfully
              this.$message.success(i18n.t('Pembelian target berhasil') as string)
              const loading = Loading.service({ fullscreen: true })
              await this.urlRouter()
              loading.close()
              this.initialize()
            } else {
              // Request failed
              this.$message.error(i18n.t('Permintaan gagal') as string)
            }
          })
          .finally(() => (this.confirmLoading = false))
      })
      .catch(() => {
        /** Cancel action */
      })
  }
}
